import { CookiesPolicyPageComponent } from '@app/shared/components/cookies-policy-page/cookies-policy-page.component';

export const sharedModuleRoutes = [
  {
    path: 'cookie-policy',
    data: { bodyCssClass: 'bjootify-cookie-policy' },
    component: CookiesPolicyPageComponent
  }
];
